function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdcLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg2855",
    width: 177.69382,
    height: 83.478752,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g2865",
    transform: "matrix(0,-1.25,-1.25,0,250.19375,517.055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2891"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2893",
    clipPath: "url(#clipPath2895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 389.529,90.506 c 0,13.038 -0.013,45.194 -0.013,45.194 l 24.062,0 c 0,0 0.121,-34.308 0.045,-48.389 -2.007,-35.616 -62.784,-42.244 -66.924,-0.428 0,10.087 0.28,48.817 0.28,48.817 l 22.949,0 c 0,0 0,-35.801 0,-45.441 0,-12.047 19.588,-12.047 19.601,0.247",
    style: {
      fill: "#0079c2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2899"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m 346.985,139.502 22.985,0 0,60.653 -22.985,0 0,-60.653 z",
    style: {
      fill: "#4f8536",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2901"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 377.506,137.191 2.6403,0 0,2.8138 -2.6403,0 0,-2.8138 z",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2903"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 381.572,193.052 5.019,-4.217 0,-2.897 -13.528,0 0,3.286 8.441,0 -4.246,3.578 0,0.501 4.246,3.542 -8.441,0 0,3.285 13.528,0 0,-2.904 -5.019,-4.174",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2905"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 373.063,179.659 13.528,0 0,3.2859 -13.528,0 0,-3.2859 z",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2907"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 386.591,168.881 -13.528,-5.836 0,3.528 2.657,1.08 0,5.918 -2.657,0.98 0,3.491 13.528,-5.328 0,-3.833 z m -8.494,-0.263 5.256,2.135 -5.256,1.94 0,-4.075",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 381.572,154.391 5.019,-4.216 0,-2.897 -13.528,0 0,3.286 8.441,0 -4.246,3.578 0,0.501 4.246,3.541 -8.441,0 0,3.286 13.528,0 0,-2.905 -5.019,-4.174",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2911"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 373.063,140.999 13.528,0 0,3.2859 -13.528,0 0,-3.2859 z",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2913"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 386.583,135.673 0,-5.802 c 0,-2.237 -0.632,-4.008 -1.893,-5.314 -1.262,-1.305 -2.894,-1.958 -4.895,-1.958 -2.099,0 -3.747,0.661 -4.944,1.983 -1.198,1.321 -1.796,3.207 -1.796,5.656 l 0,5.435 13.528,0 z m -2.482,-3.286 -8.564,0 0,-2.129 c 0,-1.381 0.391,-2.437 1.175,-3.17 0.784,-0.732 1.818,-1.098 3.102,-1.098 1.329,0 2.375,0.371 3.14,1.113 0.765,0.741 1.147,1.806 1.147,3.193 l 0,2.091",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2915"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 386.583,115.066 -13.528,-5.836 0,3.528 2.656,1.08 0,5.918 -2.656,0.98 0,3.491 13.528,-5.329 0,-3.832 z m -8.494,-0.264 5.256,2.136 -5.256,1.94 0,-4.076",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2917"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 386.583,109.183 0,-5.802 c 0,-2.237 -0.632,-4.008 -1.893,-5.313 -1.262,-1.306 -2.894,-1.959 -4.895,-1.959 -2.099,0 -3.747,0.662 -4.944,1.983 -1.198,1.322 -1.796,3.208 -1.796,5.656 l 0,5.435 13.528,0 z m -2.482,-3.286 -8.564,0 0,-2.128 c 0,-1.381 0.391,-2.438 1.175,-3.17 0.784,-0.732 1.818,-1.098 3.102,-1.098 1.329,0 2.375,0.371 3.14,1.113 0.765,0.741 1.147,1.805 1.147,3.193 l 0,2.09",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 375.537,85.484 -2.482,0 0,9.718 13.528,0 0,-9.578 -2.482,0 0,6.292 -2.831,0 0,-6.013 -2.482,0 0,6.013 -3.251,0 0,-6.432",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2921"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 355.274,190.209 -2.93,0 c -0.89,1.035 -1.335,2.122 -1.335,3.26 0,1.467 0.663,2.636 1.99,3.507 1.326,0.872 2.962,1.307 4.905,1.307 1.944,0 3.593,-0.457 4.949,-1.373 1.355,-0.915 2.034,-2.115 2.034,-3.6 0,-1.182 -0.393,-2.181 -1.179,-2.997 l -2.981,0 c 0.909,1.001 1.363,1.95 1.363,2.847 0,0.878 -0.388,1.597 -1.162,2.154 -0.774,0.559 -1.761,0.837 -2.96,0.837 -1.206,0 -2.201,-0.276 -2.986,-0.828 -0.784,-0.552 -1.176,-1.258 -1.176,-2.119 0,-0.424 0.09,-0.833 0.271,-1.228 0.181,-0.395 0.58,-0.984 1.197,-1.767",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2923"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 364.887,184.167 c 0,-1.418 -0.696,-2.564 -2.087,-3.438 -1.392,-0.874 -3.011,-1.311 -4.857,-1.311 -1.873,0 -3.496,0.444 -4.872,1.33 -1.375,0.887 -2.062,2.027 -2.062,3.419 0,1.406 0.684,2.551 2.054,3.434 1.368,0.884 2.995,1.325 4.88,1.325 1.853,0 3.473,-0.438 4.862,-1.315 1.388,-0.877 2.082,-2.025 2.082,-3.444 z m -11.081,0 c 0,-0.785 0.38,-1.417 1.142,-1.897 0.762,-0.48 1.762,-0.719 3,-0.719 1.244,0 2.246,0.239 3.005,0.719 0.758,0.48 1.137,1.112 1.137,1.897 0,0.786 -0.379,1.42 -1.137,1.903 -0.759,0.483 -1.761,0.724 -3.005,0.724 -1.238,0 -2.238,-0.241 -3,-0.724 -0.762,-0.483 -1.142,-1.117 -1.142,-1.903",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 364.677,171.805 0,-2.062 -7.66,0 c -1.971,0 -3.465,0.358 -4.482,1.074 -1.017,0.716 -1.526,1.738 -1.526,3.068 0,1.31 0.515,2.328 1.545,3.054 1.03,0.725 2.512,1.088 4.444,1.088 l 7.679,0 0,-2.062 -7.76,0 c -0.94,0 -1.694,-0.19 -2.261,-0.569 -0.567,-0.38 -0.85,-0.875 -0.85,-1.487 0,-0.637 0.289,-1.147 0.869,-1.529 0.58,-0.383 1.405,-0.575 2.474,-0.575 l 7.528,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 364.677,159.576 -13.458,0 0,1.721 8.622,4.572 -8.622,0 0,2.062 13.458,0 0,-1.892 -8.227,-4.4 8.227,0 0,-2.063",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 364.677,150.204 -2.482,0 0,3.007 -10.976,0 0,2.062 10.976,0 0,3.006 2.482,0 0,-8.075",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 351.219,146.649 6.202,0 7.256,3.251 0,-2.492 -4.23,-1.79 4.23,-1.824 0,-2.493 -7.176,3.286 -6.282,0 0,2.062",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2933"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdcLogo);
export default __webpack_public_path__ + "static/media/mdc-logo.59bda31a7055df825debcdcf1e40e417.svg";
export { ForwardRef as ReactComponent };